export default {
  classifieds: [],
  classifiedInfos: {
    id: null,
    url: null,
    activated: true,
    schedule_publish_at: null,
  },
  totalPages: 1
}
